import state from "./moduleCameraListState.js";
import mutations from "./moduleCameraListMutations.js";
import actions from "./moduleCameraListActions.js";
import getters from "./moduleCameraListGetters.js";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
